// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3Cdl9","buttons":"PendingPaymentAlert_buttons__3aUHX"};